module.exports = __webpack_public_path__ + "img/b044df1ab14f601e7c4072ac8af47ab7.png";